import * as React from 'react';

import * as style from './MoreReviewsButton.css';
import { ButtonLink } from '../ButtonLink';

export interface IMoreReviewsButtonProps {
  onClick(): void;
}

// INFO: Используется для отзывов и вопросов
export const MoreReviewsButton: React.FC<IMoreReviewsButtonProps> = props => {
  const { onClick } = props;

  return (
    <div className={style['container']}>
      <ButtonLink testId="MoreReviews" onClick={onClick} fullWidth={true}>
        Показать ещё
      </ButtonLink>
    </div>
  );
};
